import {Component, OnInit} from '@angular/core';
import {Role} from 'src/app/models/role';
import {RoleMenu, SettingsService} from '../settings.service';
import {DropdownValues, DropdownSelectionMode, DropdownValue} from 'src/app/widgets/dropdown/dropdown.component';
import {AuthService, RolePermission} from 'src/app/services';
import {LocalStorageService} from 'src/app/services/local-storage.service';
import {Title} from '@angular/platform-browser';

@Component({
    selector: 'app-menu-items-by-role',
    templateUrl: './menu-items-by-role.component.html',
    styleUrls: ['./menu-items-by-role.component.scss'],
    standalone: false
})
export class MenuItemsByRoleComponent implements OnInit {
	roles: Role[] = [];
	rolesDropdown: DropdownValues = new DropdownValues();
	menuItems: RoleMenu[] = [];
	selectedRoleId: number;

	constructor(
		private authService: AuthService,
		private settingsService: SettingsService,
		private localStorageService: LocalStorageService,
		private titleService: Title
	) {}

	ngOnInit() {
		this.getRoles();
	}

	private getRoles() {
		this.titleService.setTitle('Role Menu');

		this.settingsService.getRoles(
			{
				showLoadingIndicator: true,
			}
		).subscribe(
			{
				next: (roles) => {
					this.roles = roles;
					this.selectedRoleId = roles && roles.length ? roles[0].roleId : 0;
					this.prepareRolesDropdownValues();
					this.getMenuItemsByRole();
				}
			}
		);
	}

	private prepareRolesDropdownValues() {
		this.rolesDropdown = new DropdownValues();
		this.rolesDropdown.selectionMode = DropdownSelectionMode.single;
		this.rolesDropdown.showClearButton = false;
		this.rolesDropdown.displayName = 'Role';
		this.rolesDropdown.values = this.roles.map((role) => new DropdownValue(role.roleId, role.roleName));
	}

	private getMenuItemsByRole() {
		if (!this.selectedRoleId) {
			this.menuItems = [];
			return;
		}

		this.settingsService.getMenuItemsByRole(
			this.selectedRoleId,
			{
				showLoadingIndicator: true,
			}
		).subscribe(
			{
				next: (menuItems) => {
					this.menuItems = menuItems;
					this.menuItems.sort(
						(a: RoleMenu, b: RoleMenu) => a.sortingPriority - b.sortingPriority
					);
				}
			}
		);
	}

	public isMenuEnabled(roleMenu: RoleMenu): boolean {
		let parentRoleMenu: RoleMenu = this.menuItems.find((item) => item.menuId === roleMenu.isParent);

		if (parentRoleMenu) {
			return parentRoleMenu.isActive && this.isMenuEnabled(parentRoleMenu);
		}

		return true;
	}

	public roleChanged(roleId: number) {
		this.selectedRoleId = roleId;
		this.getMenuItemsByRole();
	}

	public save() {
		this.settingsService.saveMenuItemsByRole(
			this.menuItems,
			this.selectedRoleId,
			{
				showLoadingIndicator: true,
			}
		).subscribe(
			{
				next: () => {
					this._changeMenu();
				}
			}
		);
	}

	private _changeMenu() {
		this.authService.getPermissions(
			{
				showLoadingIndicator: true,
			}
		).subscribe(
			{
				next: (permissions) => {
					this.localStorageService.set(RolePermission.storage_key, permissions);
				}
			}
		);
	}
}
